import * as types from './mutation-types'

export default {
  [types.BOOTSTRAP_EMAIL_ACTIONS] (state, emailActions) {
    state.emailActions = emailActions
  },
  [types.PLACEHOLDERS] (state, placeholders) {
    state.placeholders = placeholders
  },

  [types.TEMPLATE_VERSIONS] (state, templateVersions) {
    state.templateVersions = templateVersions
  },
  [types.SET_TOTAL_EMAIL_ACTIONS] (state, totalEmailActions) {
    state.totalEmailActions = totalEmailActions
  },
  [types.ADD_COMMUNICATION] (state, data) {
    state.communications.push(data.communication)
  },
  [types.SET_SELECTED_EMAILACTIONS] (state, data) {
    state.selectedEmailActions = data
  },
  [types.SET_SELECT_ALL_STATE] (state, data) {
    state.selectAllField = data
  },
  [types.UPDATE_COMMUNICATION] (state, data) {
    let communication = state.communications.findIndex(communication => communication.id === data.communication.id)
    state.communications[communication] = data.communication
  }
}
